var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":require('@/assets/images/custom-sound-box.jpeg')},on:{"click":function($event){return _vm.startSound()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }